export const USER_INPUT_PREVIEW_GENERAL_SEC_REQUEST = 'USER_INPUT_PREVIEW_GENERAL_SEC_REQUEST';
export const USER_INPUT_PREVIEW_GENERAL_SEC_SUCCESS = 'USER_INPUT_PREVIEW_GENERAL_SEC_SUCCESS';
export const USER_INPUT_PREVIEW_GENERAL_SEC_FAIL = 'USER_INPUT_PREVIEW_GENERAL_SEC_FAIL';